import React from 'react'
import { Navigate } from 'react-router-dom'

export default function ProtectedRoute(props) {
    const token = localStorage.getItem('docTkn') || sessionStorage.getItem('docTkn');

    if (!token)
        return <Navigate to='/login' />
    else
        return props.children
}
